// this is an autogenerated file from App/Account/Content/Settings/Content/Onboarding/CsvNoteTemplates/mutation.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__App_Account_Content_Settings_Content_Onboarding_CsvNoteTemplates($objects: [notes_templates_insert_input!]!) {
  insert_notes_templates(objects: $objects) {
    returning {
      id
      name
    }
  }
}

`